<script>
    import { onMount } from "svelte";
    import StatusMessage from "../include/StatusMessage.svelte";
    import { api_get } from "../util/api_request";
    import UserManager from "../include/UserManager.svelte";

    let response_msg;

    let users;

    let fetch_users = async () => {
        let response = await api_get("/api/admin/get_users");
        if (response.status != 200)
            response_msg = response;

        users = response.data;
    }

    onMount(fetch_users);
</script>

<div class="content">
    <div class="container">
        <h1>Admin panel</h1>
        <hr>
        <StatusMessage message={response_msg} />
        <h2>All users</h2>

        <div class="grid">
            {#if users}
            {#each users as user}
            <UserManager bind:response={response_msg} user_data={user} />
            {/each}
            {/if}
        </div>
    </div>
</div>

<style>
    .grid {
        grid-template-columns: 1fr 1fr 1fr;
    }
</style>